export const hexagons = () => {

	let els = document.querySelectorAll('[data-hexagon-hover="inactive"]')

	if (!els.length || window.innerWidth > 782) return

	els.forEach(el => {
		el.addEventListener('click', () => {
			console.log('click2')
			if (el.dataset.hexagonHover == 'inactive') {
				console.log('click3')
				el.dataset.hexagonHover = 'active'
			} else {
				console.log('click4')
				el.dataset.hexagonHover = 'inactive'
			}
		})
	})
}

export default () => { }